<template>
  <div>
    <v-snackbar class="custom" :timeout="-1" v-model="snackbar" right>
      <div class="ctn_notify">
        <div class="ctn_header">
          <div class="ctn_col_header">
            <span class="_box_blue">IDX {{ Item.idx }} </span>
            <span class="_box_blue">NUI {{ Item.nui }}</span>
          </div>
          <div class="ctn_col_header _der">
            <span class="_box_red">Acción {{ Item.action }}</span>
          </div>
        </div>
        <p class="ctn_notify_date">{{ Item.date | formatDateFrom }}</p>
        <p class="ctn_notify_text" v-html="this.Text"></p>
      </div>
      <div class="ctn_notify_footer"></div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="editItem(Item)">
          Marcar como leído
        </v-btn>
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  name: "NotifyAlert",
  props: {
    Item: {
      type: Object
    },
    Text: {
      type: String
    },
    Timeout: {
      type: Number
    },
    Flag: {
      type: Boolean
    }
  },
  data() {
    return {
      snackbar: false
    };
  },
  async mounted() {
    this.snackbar = await this.Flag;
  },
  methods: {
    ...mapActions(["updateNotify"]),
    editItem(param) {
      let send = {
        device: param.device,
        _id: param._id
      };
      this.updateNotify(send);
      this.snackbar = false;
    },
    restore(v) {
      if (v) {
        this.snackbar = v;
      } else {
        this.snackbar = this.Flag;
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.snackbar;
      },
      set(value) {
        if (!value) {
          this.show = value;
        }
      }
    }
  },
  filters: {
    formatDateFrom: (value) => {
      if (value) {
        return moment(value)
          .locale("es")
          .fromNow();
      }
      return "-";
    }
  }
};
</script>
<style lang="scss">
.v-snack.custom {
  .v-snack__wrapper {
    background-color: #00140c;
    display: flex;
    flex-direction: column;
    max-width: 480px;
    .v-snack__action {
      align-self: flex-end;
      .v-btn {
        color: #00e083;
        margin: 5px;
      }
    }
  }
}
.ctn_notify {
  .ctn_header {
    display: flex;
    flex-direction: row;
    .ctn_col_header {
      flex: 1 1 auto;
      &._der {
        text-align: right;
      }
    }
  }
  span {
    display: inline-block;
    padding: 2px 10px;
    font-size: 0.75rem;
    border-radius: 4px;
    margin-right: 10px;
    &._box_blue {
      padding: 0;
      color: #fff;
      font-weight: 600;
    }
    &._box_red {
      background-color: #002918;
      color: #fff;
    }
  }
  p {
    &.ctn_notify_title {
      color: #232ed1;
      font-size: 0.9rem;
      margin-bottom: 0;
      font-weight: 600;
    }
    &.ctn_notify_date {
      padding: 5px 0;
      color: #ebfff7;
      font-size: 0.9rem;
      margin-bottom: 0;
      font-weight: 600;
    }
    &.ctn_notify_text {
      font-size: 0.9rem;
      margin-bottom: 0;
      color: #ebfff7;
      line-height: 1.4;
    }
  }
}
</style>
